module.exports = __webpack_public_path__ + "img/px40-celular.bccfe12e.png";